module.exports = __webpack_public_path__ + "static/media/winner.26064e08.webp";